
export const BEGIN_ACTION = 'BEGIN_ACTION';
export const END_ACTION = "END_ACTION";
export const END_ACTION_WITHERROR = "END_ACTION_WITHERROR";
export const SET_ENTITIES = "SET_ENTITIES";